import { Children } from "react";
import { Box, Stack } from "@mui/material";

/**
 * @param {{ children: React.ReactNode, columnWidth?: 6 | 12 }} props
 * `columnWidth` 6 = half width from `sm` up; 12 = full width.
 */
function PriceHistoryRecordFieldRow({ children, columnWidth = 6 }) {
  const childArray = Children.toArray(children).filter(Boolean);

  if (columnWidth === 12) {
    return (
      <Stack spacing={1.5} sx={{ width: "100%" }}>
        {childArray.map((child, index) => (
          <Box key={index} sx={{ width: "100%", minWidth: 0 }}>
            {child}
          </Box>
        ))}
      </Stack>
    );
  }

  if (childArray.length === 1) {
    return (
      <Box sx={{ width: { xs: "100%", sm: "calc(50% - 6px)" }, minWidth: 0 }}>
        {childArray[0]}
      </Box>
    );
  }

  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      spacing={1.5}
      sx={{ width: "100%" }}
    >
      {childArray.map((child, index) => (
        <Box key={index} sx={{ flex: 1, minWidth: 0 }}>
          {child}
        </Box>
      ))}
    </Stack>
  );
}

export default PriceHistoryRecordFieldRow;
